/**
 * @generated SignedSource<<c91ef9e696281cbda3add9ea98d038ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskAllIssuesScreenTodoList_todos$data = {
  readonly id: string;
  readonly todos: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly categoryId: string;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"TodoListItem_todo">;
      };
    }>;
  };
  readonly " $fragmentType": "TaskAllIssuesScreenTodoList_todos";
};
export type TaskAllIssuesScreenTodoList_todos$key = {
  readonly " $data"?: TaskAllIssuesScreenTodoList_todos$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskAllIssuesScreenTodoList_todos">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "todos"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "sectionId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./TaskAllIssuesListTodoQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "TaskAllIssuesScreenTodoList_todos",
  "selections": [
    {
      "alias": "todos",
      "args": [
        {
          "kind": "Variable",
          "name": "sectionId",
          "variableName": "sectionId"
        }
      ],
      "concreteType": "TodoConnection",
      "kind": "LinkedField",
      "name": "__TaskAllIssuesListTodo_todos_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Todo",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TodoListItem_todo"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Task",
  "abstractKey": "__isTask"
};
})();

(node as any).hash = "f9243b1071e7fe13891a99d10244185f";

export default node;
